/**
 * Malé textové helpery — jediná definícia pre admin, mobil, API aj weby.
 */

/**
 * Slovenský plurál: 1 → prvý tvar, 2–4 → druhý, inak (0, 5+, záporné) tretí.
 * pluralizeSk(3, ['kontakt', 'kontakty', 'kontaktov']) → 'kontakty'
 */
export function pluralizeSk(n: number, forms: readonly [one: string, few: string, many: string]): string {
  if (n === 1) return forms[0]
  if (n >= 2 && n <= 4) return forms[1]
  return forms[2]
}

/** „Meno Priezvisko"; chýbajúca časť (meno kontaktu je nepovinné) sa vynechá, bez osoby ''. */
export function personName(p: { firstName?: string | null; lastName?: string | null } | null | undefined): string {
  return p ? [p.firstName, p.lastName].filter(Boolean).join(' ').trim() : ''
}
